import React, { useEffect, useState } from 'react';
import haLogo from '../img/ha_logo.gif';
import { makeStyles } from "@mui/styles";
import { Typography, Grid, Paper, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { enTitle, cnTitle, enDisclaimer, cnDisclaimer } from '../utils/static';


const useStyles = makeStyles((theme) => ({
    logo: {
        position: 'absolute',
        left: 5,
        verticalAlign: 'middle',
        [theme.breakpoints.down("sm")]: {
            position: 'relative',
            width: '32%',
            left: 0,
            top: 5
        }
    },
    title: {
        display: 'inline-block',
        //color: 'rgb(0, 112, 192)',
        color: '#ed3587',
        fontSize: 30,
        fontWeight: 'bold',
        left: 45,
        position: 'relative',
        verticalAlign: 'middle',
        textAlign: 'center',
        width: '50%',
        [theme.breakpoints.down("md")]: {
            fontSize: 20,
            //left: 0,
            width: '50%'
        },
        [theme.breakpoints.down("sm")]: {
            marginTop: 10,
            left: 0,
            width: '100%'
        }
    },
    subTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        textDecoration: 'underline',
        marginBottom: 10
    }

}))

export default function RescanCode() {
    const classes = useStyles();

    return (
        <div>
            <div className="page-top-heading">
                <img src={haLogo} alt="logo" className={classes.logo} />
                <div className={classes.title}>
                    {enTitle}
                    <br />
                    {cnTitle}
                </div>
            </div>
            <div className={classes.subTitle} style={{ marginLeft: "20px", marginRight: "20px", marginTop: "20px", textDecoration: 'none' }}>
                <div>Please scan QR code if you want to verify the Medical Certificate again.</div>
                <div>如需再次驗證本醫生證明書，請掃描二維碼。</div>
            </div>
        </div>
    )
}